import React from "react";
import { Icon } from "semantic-ui-react";
import "./index.css";

const CreateCollectionButton = ({ onClick, ...rest }) => {
  return (
    <div className="new-collection-btn" {...rest}>
      <Icon link circular name="plus" className="icon" />
      <a onClick={onClick} className="text">
        New Collection
      </a>
    </div>
  );
};

export default CreateCollectionButton;



// WEBPACK FOOTER //
// ./src/scenes/CollectionsPage/components/CreateCollectionButton/index.js